import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';

@Component({
  selector: 'opt-date-time-item-renderer',
  templateUrl: './date-time-item-renderer.component.html',
  styleUrls: ['./date-time-item-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateTimeItemRendererComponent implements OnInit, IItemRenderer {
  @Input() id: string;
  @Input() value: Date;

  constructor() {}

  ngOnInit(): void {}
}
